import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WorkspaceLink } from '@platform/navigation/WorkspaceLink';
import { useGetStatsQuery, useMeQuery } from '@platform/state/api';
import { useElsewhereRecordsQuery } from './elsewhereRecordsApi';
import type { IBaElsewhereNoteProps } from './IBaElsewhereNoteProps';
import { PLATFORM_ANALYSIS_MODULE } from './platformAnalysisModule';
import './elsewhere.css';

/**
 * Примітка модуля «Бізнес-аналіз» у просторі без власних записів (прототип v4 baElsewhere): «Аналіз усієї платформи зберігається в «…»
 * (N елементів). У цьому робочому просторі власного немає.» і «Перейти до цього робочого простору» — та сама сторінка в першому іншому
 * просторі користувача, де записи є (адреса та сама — змінюється лише поточний простір, ADR-028). Для інших модулів, простору з записами чи без іншого простору — нічого.
 */
export function BaElsewhereNote({ ws, moduleKey, rtKey }: IBaElsewhereNoteProps) {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const active = moduleKey === PLATFORM_ANALYSIS_MODULE;
  const { data: me } = useMeQuery(undefined, { skip: !active });
  const { data: stats } = useGetStatsQuery({ ws, rt: rtKey, by: 'status', params: {} }, { skip: !active });
  const candidates = (me?.workspaces ?? []).filter((w) => w.id !== ws).map((w) => w.id);
  const { data: other } = useElsewhereRecordsQuery({ rt: rtKey, candidates }, { skip: !active || stats?.total !== 0 || !candidates.length });
  if (!active || stats?.total !== 0 || !other) return null;
  const name = me?.workspaces.find((w) => w.id === other.ws)?.name ?? '';
  return (
    <div className="ins-else" role="note">
      <span className="ins-else__text">{t('insightBody.elsewhere.text', { name, count: other.total })}</span>
      <WorkspaceLink className="ins-else__btn" ws={other.ws} to={`${pathname}${search}`}>{t('insightBody.elsewhere.switch')}</WorkspaceLink>
    </div>
  );
}
